import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';

export function StickyHeader({
  children,
  className,
  stickyContainerClassName,
}: {
  children: React.ReactNode;
  className?: string;
  maxWidth?: string;
  stickyContainerClassName?: string;
}) {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [headerAtTop, setHeaderAtTop] = React.useState(false);

  React.useEffect(() => {
    if (!headerRef.current) return;
    const handleScroll = () => {
      const height = headerRef.current?.clientHeight || 0;
      const headerElement = headerRef.current;
      const rect = headerElement?.getBoundingClientRect();
      const isAtTop = rect?.top && rect.top <= -height;

      if (isAtTop) {
        setHeaderAtTop(true);
        return;
      }
      setHeaderAtTop(false);
      return;
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  //TODO: https://linear.app/sound/issue/ENG-6662/improve-sticky-header-animation
  return (
    <>
      <div className={twMerge(className)} ref={headerRef}>
        {children}
      </div>
      <AnimatePresence>
        {headerAtTop && (
          <motion.div
            initial={{ opacity: 0, y: -100, display: headerAtTop ? 'flex' : 'none' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.2 }}
            className="fixed left-0 right-0 top-0 z-stickyHeader flex items-center justify-center bg-white shadow-tertiary md:left-sidebar-md lt:left-sidebar-lt"
          >
            <div
              className={twMerge('w-full max-w-content px-4 md:px-6 ', stickyContainerClassName)}
            >
              <div className={className}>{children}</div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
